import {Button, Stack, Text, Textarea} from "@mantine/core";
import {useState} from "react";
import {IconBrandSentry} from "@tabler/icons-react";
import {ContextModalProps} from "@mantine/modals";

export function SentryCrashReportModal({innerProps: {processEvent}}: ContextModalProps<{ eventId: string, processEvent: (m: string)=>void }>) {
	const [message, setMesasge] = useState<string | undefined>(undefined)

	const submitCrash = () => {
		if (message != undefined)
			processEvent(message)
	}


	return <>
		<Stack>
			<Textarea label={"Zpráva"} withAsterisk
					  placeholder={"Co se stalo? Co jste dělal/a?"} value={message}
					  onChange={e => setMesasge(e.target.value)}></Textarea>
			<Button onClick={submitCrash} leftSection={<IconBrandSentry/>}>Odeslat</Button>
			<Text size={"xs"} ta={"center"}>Hlášení se odešle do externí služby, kterou používáme k zachycování chyb.</Text>
		</Stack>
	</>
}